export default __webpack_public_path__ + "static/media/simple4.cbc818a6.png";